import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportdef',
  templateUrl: './reportdef.component.html',
  styleUrls: ['./reportdef.component.css']
})
export class ReportdefComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
